@if (!visualizationEditor()) {
<header tuiNavigationHeader tuiTheme="light">
  <span tuiNavigationLogo>
    <img
      [src]="seasonalLogo.src()"
      alt="Reverb"
      width="160"
      height="84"
      priority
    />
  </span>
  <hr />
  <!-- <button appearance="primary" iconStart="@tui.fa.solid.plus" tuiButton type="button">
    Create Client
  </button>
  <button iconStart="@tui.fa.solid.ellipsis" tuiIconButton type="button">
    More
  </button> -->
</header>
}
<div class="flex min-h-0 grow" tuiTheme="light">
  <aside tuiTheme="light" [class.visualization-aside]="visualizationEditor()" [style.height]="visualizationEditor() ? '100dvh' : 'calc(100vh - 48px)'" [tuiNavigationAside]="expanded()">
    <header>
    @if (visualizationEditor()) {
      <a class="visualization-logo" routerLink="/clients" aria-label="Reverb home" (click)="onSidebarLinkClick($event, '/clients')"><img src="reverb/ReverbLogo.svg" alt="Reverb" width="40" height="40" /></a>
    }

      <a
        iconStart="Dashboard3"
        tuiAsideItem
        routerLink="/clients"
        (click)="onSidebarLinkClick($event, '/clients')"
      >
        Home
      </a>
    </header>
    <a iconStart="Cog" tuiAsideItem routerLink="/settings" (click)="onSidebarLinkClick($event, '/settings')">
      Settings
    </a>
    <a *isAdmin [href]="mvcAppUrl + '/Admin'" iconStart="@tui.fa.solid.shield-halved" tuiAsideItem>
      Admin
    </a>
    <a [href]="mvcAppUrl + '/ReportType'" iconStart="FileReport" tuiAsideItem>
      Supported Tests
    </a>
    <a href="mailto:support@reverbreports.com" iconStart="CustomerSupport1" tuiAsideItem>
      Support
    </a>
    <a href="https://reverb-community.circle.so/" target="_blank" iconStart="circle-user" tuiAsideItem>
      Reverb Circle
    </a>
    <a [href]="mvcAppUrl + '/'" iconStart="@tui.fa.solid.arrow-left" tuiAsideItem>Reverb 1.0</a>
    <a [href]="mvcAppUrl + '/Account/SignOut'" iconStart="Logout1" tuiAsideItem>Logout</a>
    <footer>
      @let user = user$ | async;
      <button iconStart="@tui.fa.solid.user" tuiAsideItem type="button">
        {{ user?.displayName }}
      </button>
      <button tuiAsideItem type="button" [iconStart]="
          expanded()
            ? '@tui.fa.solid.chevron-left'
            : '@tui.fa.solid.chevron-right'
        " (click)="handleToggle()">
        {{ expanded() ? "Collapse" : "Expand" }}
      </button>
    </footer>
  </aside>
  <main [class.visualization-main]="visualizationEditor()" tuiTheme="light" class="h-full min-h-0 min-w-0 w-full overflow-hidden">
    <router-outlet></router-outlet>
  </main>
</div>